import { BooleanValueProperty } from './properties/boolean-property.model';
import { TextProperty } from './properties/text-property.model';
import { Widget } from './form-widget.model';

export class FbTextboxWidget extends Widget {
  constructor(data: any = {}) {
    super(data);
    this.title = 'Text Field';
    this.name = 'fb-textbox-composite';
    this.properties = this.defaultProperties(data.properties);
  }

  defaultProperties(props: any) {
    if (Array.isArray(props)) {
      const labelProp = new TextProperty({ title: 'Header', value: '' });
      const contentProp = new TextProperty({
        title: 'Content',
        value: '',
      });
      const required = new BooleanValueProperty({ title: 'Required' });
      const optionsProp = props.map((item) => {
        return {
          required: new BooleanValueProperty(item.required || { title: 'Required' }),
          text: new TextProperty(item.text || { title: 'Question' }),
          placeholder: new TextProperty(item.placeholder),
          value: new TextProperty(item.value),
          hint: new TextProperty(item.hint || { title: 'Hint' }),
        };
      });

      props = {
        text: labelProp,
        content: contentProp,
        required: required,
        columns: optionsProp,
      };
    }
    return props;

    // if(props instanceof Array) {
    //     const result = [];
    //     props.forEach(item => {
    //         const properties = this.getProperties(item);
    //         result.push(properties)
    //     })
    //     return result;
    // } else {
    //     const properties = this.getProperties(props || {});
    //     return [properties];
    // }
  }

  getProperties(props: any = {}) {
    const properties = {
      text: new TextProperty({
        value: props.text ? props.text.value : 'Text Field 1',
      }),
      placeholder: new TextProperty({
        title: 'Placeholder',
        value: props.placeholder ? props.placeholder.value : 'Type here',
      }),
      value: new TextProperty(props.value || ''),
      columns: new TextProperty({
        title: 'Columns',
        value: props.columns ? +props.columns.value : 1,
      }),
    };
    return properties;
  }

  isValid() {
    let valid = true;

    if (!this.isRequired()) {
      return true;
    }

    this.properties.columns.forEach((item) => {
      if (!item.value.value) {
        valid = false;
      }
    });

    return valid;
  }
}
